const cliente = {
  readClienteAdmin: '{{uuid_academia}}/cliente-persona',
  readClienteAlumno: '{{uuid_academia}}/cliente-persona/{{uuid_alumno}}',
  readIsClienteAlumno: '{{uuid_academia}}/is-cliente-persona/{{uuid_alumno}}',
  updateClienteAdmin: '{{uuid_academia}}/cliente-persona',
  updateClienteAlumno: '{{uuid_academia}}/cliente-persona/{{uuid_alumno}}'
}

export default cliente
